import { useRef, useState } from "react";

import { IMetodoPago } from "../../../interfaces/IMetodoPago";
import { IOpcion } from "../../../interfaces/OpcionReembolso";
import { dataDisponible } from "../models/dataDisponible";
import { Toast } from "primereact/toast";


interface IState {
    loadingTyC: boolean;
    monto: number,
    dataDisponible?: dataDisponible[],
    opcion?: IOpcion[],
    asked: boolean,
    visible: boolean,
    metodosPago?: IMetodoPago,
    redirect: boolean,
    redirectLogin: boolean,
    url: string,
    tycVisible: boolean,
    habilitadoLanet: boolean
}

const initialState = {
    tycVisible: false, 
    loadingTyC: true, 
    redirectLogin: false,
    monto: 0, 
    visible: true, 
    asked: false,
    redirect: false, 
    url: "",
    habilitadoLanet: true,
    opcion:[]
}

const useInitialState = () => {
    const [state,setState] = useState<IState>(initialState);
    const [isEmpresarial,setIsEmpresarial] = useState<boolean>(true)
    const[requestedCard,setRequestedCard] = useState(false)
    const[adelanto,setAdelanto] = useState("")
    return{
        state,
        setState,
        isEmpresarial,setIsEmpresarial,
        requestedCard,setRequestedCard,
        adelanto,setAdelanto
    }
}

export default useInitialState